WatchSumo.WeeklyAvailability = class WeeklyAvailability extends WatchSumo.Graph {
  render() {
    return Morris.Line({
      element: this.element,
      data: this.data,
      xkey: 'date',
      ykeys: ['percentage'],
      labels: ['Availability'],
      xLabels: "day",
      postUnits: "%",
      lineWidth: 1,
      lineColors: ["#5da423"]
    });
  }
};